export enum FlightsServiceRoutes {
  Flight_Search = "flight-search",
  List_Offers = "list-offers",
}
